import React, { Component, PropTypes } from 'react';

import {
  NitroLoading,
  NitroTable,
  NitroFormatter,
  NitroText,
  NitroIcon,
} from 'nitro-components';

import {
  getChartUtilisationCategoryStyle,
  shouldEnableDetails,
  getInsightTableMultipleCategoryHeading,
} from '../helpers';

import { transformTableDataToInsightTableComponent } from '../DataTransformer';

class InsightTable extends Component {
  getTable = (data, clickCategory) =>
    transformTableDataToInsightTableComponent(data, clickCategory);

  render() {
    const { data, clickCategory } = this.props;

    return Object.keys(data).length ? (
      this.getTable(data, clickCategory)
    ) : (
      <NitroLoading center />
    );
  }
}

InsightTable.propTypes = {
  data: PropTypes.object.isRequired,
  clickCategory: PropTypes.func,
};

export default InsightTable;



// WEBPACK FOOTER //
// ./src/features/insights/components/InsightTable.js